import React, { useState } from "react";
import styled from "styled-components";

interface BannerProps {
  isSettings?: boolean;
}

const Banner = styled.div<BannerProps>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  bottom: ${(props) => (props.isSettings ? "0" : "27px")};
  width: 100%;
  background-color: #474747;
  color: white;
  text-align: center;
  padding: 10px;
  z-index: 1000;
  font-size: 12px;

  @media (min-width: 768px) {
    font-size: 14px;
    flex-direction: row;
  }
`;
interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
}
const Button = styled.button<ButtonProps>`
  background-color: ${(props) => props.backgroundColor};
  color: #2c2c2c;
  border: none;
  border-radius: 99px;
  padding: 10px 20px;
  margin-left: 10px;
  cursor: pointer;
  font-size: 10px;
  @media (min-width: 768px) {
    font-size: 14px;
  }

  &:hover {
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;

const Cookies: React.FC = () => {
  const [showBanner, setShowBanner] = useState(true);

  const path = window.location.pathname;
  const isSettings = path.includes("settings");

  const handleAccept = async () => {
    localStorage.setItem("cookie-accept", "true");
    setShowBanner(false);
  };
  if (localStorage.getItem("cookie-accept")) {
    return null;
  }
  return (
    <>
      {showBanner && (
        <Banner isSettings={isSettings}>
          <p>
            Usamos cookies para proporcionar melhor desempenho, experiência de
            navegação e melhoria continua dos nossos sistemas. Ao continuar
            navegando neste site, você declara estar ciente dessas condições.
          </p>
          <div>
            <Button
              onClick={() => handleAccept()}
              backgroundColor="#77EC84"
              hoverBackgroundColor="#72E27F"
            >
              ESTOU CIENTE
            </Button>
          </div>
        </Banner>
      )}
    </>
  );
};

export default Cookies;
